export const denseText = (text: string) =>
  text
    .replace(/[\t]/g, ' ') // タブ文字をスペースに
    .replace(/^[\x20]+/gm, '') // 行頭のスペースを削除
    .replace(/[\x20]+$/gm, '') // 行末のスペースを削除
    .replace(/[\x20]{2,}/g, ' ') // 連続するスペースを一つに
    .replace(/\n{2,}/g, '\n\n'); // 連続する改行を 1 つに
